import { render, staticRenderFns } from "./PriceDetailsContent.vue?vue&type=template&id=7a6680d1&scoped=true"
import script from "./PriceDetailsContent.vue?vue&type=script&lang=ts"
export * from "./PriceDetailsContent.vue?vue&type=script&lang=ts"
import style0 from "./PriceDetailsContent.vue?vue&type=style&index=0&id=7a6680d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6680d1",
  null
  
)

export default component.exports